import { useInjection } from 'inversify-react';
import { ReactElement, useState } from 'react';
import { IOverlayLoaderStore } from '../../../../../../../modules/common/OverlayLoader.store';
import { ImageFilters } from '../../components/filters/ImageFilters';
import { IProjectDetailsImagesStore } from '../../projectDetailsImages.store';
import { getActiveFiltersCount } from '../../services/imageFilterHelper';

export const ImageFiltersContainer = (): ReactElement => {
  const imagesStore = useInjection(IProjectDetailsImagesStore.$);
  const overlayLoaderStore = useInjection(IOverlayLoaderStore.$);

  const [showModal, setShowModal] = useState(false);

  const handleModalShow = (): void => {
    setShowModal(true);
  };

  const handleModalClose = (): void => {
    if (overlayLoaderStore.isSpinnerVisible('details-images-loading')) {
      return;
    }
    setShowModal(false);
  };

  return (
    <ImageFilters
      activeFiltersCount={getActiveFiltersCount(imagesStore.imageFilters)}
      isModalOpen={showModal}
      onModalClose={handleModalClose}
      onModalShow={handleModalShow}
    />
  );
};
